import {
  Box,
  Card,
  CardContent,
  Typography
} from '@mui/material';
import PropTypes from 'prop-types';

const StatisticCard = ({ 
  icon: Icon, 
  value, 
  label, 
  gradientBackground,
  ...cardProps 
}) => {
  return (
    <Card sx={{
      background: gradientBackground,
      color: 'white',
      textAlign: 'center',
      py: 2,
      height: '100%',
      ...cardProps.sx
    }}>
      <CardContent>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 1 }}>
          <Icon sx={{ fontSize: 32, mr: 1 }} />
          <Typography variant="h4" sx={{ fontWeight: 'bold' }}>
            {value}
          </Typography>
        </Box>
        <Typography variant="body1">
          {label}
        </Typography>
      </CardContent>
    </Card>
  );
};

StatisticCard.propTypes = {
  icon: PropTypes.elementType.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  label: PropTypes.string.isRequired,
  gradientBackground: PropTypes.string.isRequired,
  sx: PropTypes.object
};

export default StatisticCard;